// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Bwuz-","successIconWrapper":"styles_successIconWrapper__eibG6","successIcon":"styles_successIcon__kjJUa"};